import { render } from "./AppPageTitle.vue?vue&type=template&id=4d795a7e&scoped=true"
import script from "./AppPageTitle.vue?vue&type=script&lang=js"
export * from "./AppPageTitle.vue?vue&type=script&lang=js"

import "./AppPageTitle.vue?vue&type=style&index=0&id=4d795a7e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d795a7e"]])

export default __exports__